"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listenScrollMixin = exports.listenScrollDropDownMixin = void 0;
exports.listenScrollMixinCreateor = listenScrollMixinCreateor;
exports.listenScrollPickerMixin = void 0;
function listenScrollMixinCreateor() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var visibleKey = options.visibleKey || 'visible';
  return {
    props: {
      hideDropdownWhenScroll: {
        type: Boolean,
        default: function _default() {
          return this.$ELEMENT && this.$ELEMENT.config && this.$ELEMENT.config.hideDropdownWhenScroll || false;
        }
      }
    },
    data: function data() {
      return {
        _removeDocumentScrollListener: null
      };
    },
    mounted: function mounted() {
      var _this = this;
      if (!this.hideDropdownWhenScroll) {
        return;
      }
      var handle = function handle(event) {
        if (!_this[visibleKey]) {
          return;
        }
        if (event.target && event.target.contains(_this.$el)) {
          _this[visibleKey] = false;
        }
      };
      document.addEventListener('scroll', handle, true);
      this._removeDocumentScrollListener = function () {
        document.removeEventListener('scroll', handle, true);
      };
    },
    beforeDestroy: function beforeDestroy() {
      this._removeDocumentScrollListener && this._removeDocumentScrollListener();
    }
  };
}
var listenScrollMixin = exports.listenScrollMixin = listenScrollMixinCreateor({
  visibleKey: 'visible'
});
var listenScrollPickerMixin = exports.listenScrollPickerMixin = listenScrollMixinCreateor({
  visibleKey: 'pickerVisible'
});
var listenScrollDropDownMixin = exports.listenScrollDropDownMixin = listenScrollMixinCreateor({
  visibleKey: 'dropDownVisible'
});